module.exports = __webpack_public_path__ + "media/img/cal-ico-da90ca92aa58c76f05c82a9067bf54a2.svg";